/* eslint-disable react/display-name */
import { memo, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {
  Account_Management_List,
  getApplicationsErrorHandling,
  getAccountsonDD,
  getProfile,
  getReApply,
} from '../redux/Actions/getMethods'
import { handleLogout } from '../App'
import { ActionTypes } from '../redux/Constants/actionTypes'
import { useLDClient } from 'launchdarkly-react-client-sdk'

const JourneyRoute = memo(() => {
  const dispatch = useDispatch()
  const isLoggedIn = localStorage.getItem('login')
  const navigate = useNavigate()
  const { token } = useSelector((state) => state.authReducer)
  const { profile, getApplication, loanManagement, loadingJourneyRoute } = useSelector((state) => state.dataReducer)
  const bank = JSON.parse(localStorage.getItem(`bankConfirm-${token?.email}`))
  const startedReapplying = sessionStorage.getItem(`reAaply-${token?.email}`)
  const ldClient = useLDClient()

  useEffect(() => {
    dispatch(getApplicationsErrorHandling())
  }, [])
  
  useEffect(() => {
    if (!loadingJourneyRoute && isLoggedIn) {
      dispatch({ type: ActionTypes.LOADING_JOURNEY_ROUTE })
      const Temp = async () => {
        const getPro = await dispatch(getProfile())
        if (getPro === 404) {
          navigate('/about-you')
        } else if (getPro === 500 || getPro === 424 || getPro === 429) {
          // window.location.href = `${window.location.origin}/error`
          navigate('/error')
        } else if (getPro === 403) {
          // window.location.href = `${window.location.origin}/error`
          handleLogout(ldClient)
          navigate('/')
        }
        const getApplicationStatus = await dispatch(getReApply())
        const get_loan_account_management = loanManagement ? loanManagement : await dispatch(
          Account_Management_List()
        )
        // const getDD = await dispatch(getDdAccounts())
        if (profile && !Array.isArray(profile) && getApplicationStatus && get_loan_account_management) {
          const shouldShowUpfrontAmount = getApplication[0]?.is_general_purpose_loan || (
            ldClient?.variation('web-ask-loan-amount-upfront-for-pay-off-loans', false) &&
            getApplication[0]?.is_pay_off_loan
          )
          const isApplyPhase = getApplicationStatus?.status === 'APPLY'
          const isPolicyOkPhase = ['POLICY_OK', 'INPROGRESS', 'PENDING'].includes(getApplication[0]?.status)

          if (isApplyPhase || isPolicyOkPhase) {
            const yearsResident = profile?.address?.years_resident || 0
            const pastYearsResident = profile?.past_address?.years_resident || 0
            const missingBasicDetails = !profile?.title || !profile?.first_name || !profile?.family_name || !profile?.birthday
            const missingAddress = !profile?.address?.id || (yearsResident < 3 && pastYearsResident < 1)
            const missingEmployment = !profile?.employer_name || !profile?.occupation || !profile?.employment_status || !profile?.customer_income
            const circumstancesDone = localStorage.getItem(`circumstances-done-${token?.email}-${getApplication[0]?.id}`)

            // APPLY-only: universal pre-checks before any page routing
            let handled = false
            if (isApplyPhase) {
              const existingLoan = get_loan_account_management?.status?.length > 0
              if (existingLoan && !startedReapplying) {
                navigate('/reapply')
                handled = true
              } else if (missingBasicDetails) {
                navigate('/your-details')
                handled = true
              } else if (missingAddress) {
                navigate('/address-details')
                handled = true
              }
            }

            if (!handled) {
              switch (window.location.pathname.toString()) {
                case '/reason':
                  // valid step for both phases — APPLY pre-checks already passed
                  break
                case '/upfront-amount':
                  if (isApplyPhase) {
                    if (!getApplication[0]?.reason) { navigate('/reason'); break }
                    if (!shouldShowUpfrontAmount) { navigate('/employment'); break }
                  } else {
                    if (!shouldShowUpfrontAmount) {
                      if (missingEmployment) { navigate('/employment'); break }
                      if (!circumstancesDone) { navigate('/circumstances'); break }
                      navigate('/soft-search'); break
                    }
                    if (!getApplication[0]?.reason) { navigate('/reason'); break }
                  }
                  break
                case '/employment':
                  if (!getApplication[0]?.reason) { navigate('/reason'); break }
                  if (shouldShowUpfrontAmount && !getApplication[0]?.requested_amount) { navigate('/upfront-amount'); break }
                  break
                case '/circumstances':
                  if (!getApplication[0]?.reason) { navigate('/reason'); break }
                  if (shouldShowUpfrontAmount && !getApplication[0]?.requested_amount) { navigate('/upfront-amount'); break }
                  if (missingEmployment) { navigate('/employment'); break }
                  break
                default:
                  if (isApplyPhase) {
                    navigate('/address-details')
                  } else {
                    if (!getApplication[0]?.reason) { navigate('/reason') }
                    else if (shouldShowUpfrontAmount && !getApplication[0]?.requested_amount) { navigate('/upfront-amount') }
                    else if (missingEmployment) { navigate('/employment') }
                    else if (circumstancesDone) { navigate('/soft-search') }
                    else { navigate('/circumstances') }
                  }
                  break
              }
            }
          } else if (
            // getApplication[0]?.dd_account_number &&
            getApplication[0]?.status === 'DECLINED'
          ) {
            navigate('/partner-offer')
          } else if (getApplication[0]?.status === 'CREDIT_OK') {
            if (!profile?.employer_name || !profile?.occupation) {
              navigate('/employment')
            } else {
              navigate('/monthly-spend')
            }
          } else if (
            getApplication[0]?.status === 'APPROVED' &&
            getApplication[0]?.offer_type === 'UPDRAFT_CREDIT_INTEREST_ONLY'
          ) {
            navigate('/loanapproved')
          } else if (
            getApplication[0]?.status === 'APPROVED' &&
            getApplication[0]?.offer_type !== 'UPDRAFT_CREDIT_INTEREST_ONLY'
          ) {
            navigate('/loanapprovedfee')
          } else if (bank && getApplication[0]?.status === 'REFERRED') {
            navigate('/loanreferred')
          } else if (getApplication[0]?.status === 'REFERRED') {
            if (localStorage.getItem(`add-another-bank-account-${token?.email}`)) {
              navigate('/verify-income')
            } else {
              const accounts = await dispatch(getAccountsonDD())
              const unexpiredAccounts = (accounts ? accounts : []).filter(account => (account?.days_to_renew ? account?.days_to_renew : 0) > 0)
              if (unexpiredAccounts.length > 0) {
                navigate('/loanreferred')
              } else {
                navigate('/verify-income')
              }
            }
          } else if (getApplication[0]?.status === 'ERROR') {
            navigate('/error')
          } else if (getApplication[0]?.status === 'ACCEPTED') {
            if (getApplication[0]?.finished_at) {
              const finished_at_date = new Date(getApplication[0]?.finished_at)
              const twoDaysAgo = new Date()
              twoDaysAgo.setDate(twoDaysAgo.getDate() - 2)
              const isRecent = finished_at_date > twoDaysAgo && finished_at_date <= new Date()
              if (isRecent) {
                navigate('/manageloan')
              } else {
                navigate('/active-loan')
              }
            } else {
              navigate('/active-loan')
            }
          } else {
            if (get_loan_account_management) {
              if (
                (get_loan_account_management?.status === 'CLOSED' &&
                  get_loan_account_management?.settled_date === null) ||
                (get_loan_account_management?.status === 'CLOSED' &&
                  get_loan_account_management?.settled_date !== null) ||
                get_loan_account_management?.status === null
              ) {
                // window.location.href = `${window.location.origin}/no-active-loan`
                navigate('/no-active-loan')
              } else if (
                get_loan_account_management?.status === 'GOOD' ||
                get_loan_account_management?.status === 'OVERDUE' ||
                get_loan_account_management?.status === 'HOLIDAY' ||
                get_loan_account_management?.status === 'ARRANGEMENT' ||
                get_loan_account_management?.status === 'ARRANGEMENT_OVERDUE'
              ) {
                navigate('/active-loan')
              }
            } else if (!profile?.title || !profile?.first_name || !profile?.family_name || !profile?.birthday) {
              navigate('/your-details')
            } else if (profile?.title) {
              navigate('/address-details')
            }
          }
        }
        dispatch({ type: ActionTypes.FINISHED_LOADING_JOURNEY_ROUTE })
      }
      Temp()
    }
  }, [isLoggedIn])
  return ''
})

export default JourneyRoute
